import { zIndexStickyLayer3 } from '@xing-com/layout-tokens';

export const CARD_WIDTH = 342;
export const CARD_HEIGHT = 440;
export const CARD_HIDDEN_HEIGHT = 8;
export const CARD_GAP = 24;
export const CARD_Z_INDEX = zIndexStickyLayer3;

export const SAVED_CARDS_ITEM_WIDTH = '342px';
export const SAVED_CARDS_ITEM_HEIGHT = '115px';

export const DECK_CONTAINER_HEIGHT = CARD_HEIGHT + CARD_HIDDEN_HEIGHT * 2;
